import type { EftCountry } from '~/types/locale'
import { CountryCode } from '~/types/locale'

/**
 * Field under country apply as a patch over fields from region (replace by name)
 * If you want to remove a field already applied in region, add the same field with `type: 'remove'` under country
 */
export const eftRegions: EftCountry[] = [
  {
    countries: [CountryCode.US],
    creditAgreement: true,
    fields: [
      { name: 'paymentType', key: 'paymentType', type: 'type', rules: { required: true } },
      { name: 'financialInstitution', key: 'institution', type: 'text', rules: { required: true } },
      { name: 'routingNumber', key: 'routing', type: 'text', rules: { required: true }, confirm: true },
      { name: 'accountNumber', type: 'text', key: 'accountNumber', rules: { required: true }, confirm: true, placeholderField: 'maskedAccountNumber' }
    ]
  },
  {
    countries: [CountryCode.CA],
    creditAgreement: true,
    fields: [
      { name: 'paymentType', key: 'paymentType', type: 'type', rules: { required: true } },
      { name: 'financialInstitution', key: 'institution', type: 'text', rules: { required: true } },
      { name: 'routingNumber', key: 'routing', type: 'text', rules: { required: true }, confirm: true, mask: '*****-***' },
      { name: 'accountNumber', type: 'text', key: 'accountNumber', rules: { required: true }, confirm: true, placeholderField: 'maskedAccountNumber' }
    ]
  },
  {
    countries: [CountryCode.AU],
    creditAgreement: true,
    fields: [
      { name: 'paymentType', type: 'type', key: 'paymentType', rules: { required: true } },
      { name: 'financialInstitution', type: 'text', key: 'institution', rules: { required: true } },
      { name: 'accountHolder', type: 'text', key: 'accountHolder', rules: { required: true } },
      { name: 'accountNumber', type: 'text', key: 'accountNumber', rules: { required: true }, confirm: true, placeholderField: 'maskedAccountNumber' },
      { name: 'routingNumber', type: 'text', key: 'routing', rules: { required: true }, mask: '***-***', confirm: true }
    ]
  },
  {
    countries: [CountryCode.AT, CountryCode.DE, CountryCode.FR, CountryCode.BE, CountryCode.IE, CountryCode.NL],
    creditAgreement: true,
    fields: [
      { name: 'financialInstitution', type: 'text', key: 'institution', rules: { required: true } },
      { name: 'accountHolder', type: 'text', key: 'accountHolder', rules: { required: true } },
      { name: 'iban', type: 'text', key: 'iban', rules: { required: true }, confirm: true },
      { name: 'swiftCode', type: 'text', key: 'swift', rules: { required: true }, confirm: true }
    ]
  },
  {
    countries: [CountryCode.GB],
    creditAgreement: false,
    // debitReadonlyFieldsDisplay: [
    //   { field: 'financialInstitution', label: 'institution' },
    //   { field: 'accountHolder', label: 'accountHolder' },
    //   { field: 'routingNumber', label: 'routing' },
    //   { field: 'iban', label: 'iban' },
    //   { field: 'swift', label: 'swift' }
    // ],
    fields: [
      { name: 'financialInstitution', type: 'text', key: 'institution', rules: { required: true } },
      { name: 'accountHolder', type: 'text', key: 'accountHolder', rules: { required: true } },
      { name: 'iban', type: 'text', key: 'iban', rules: { required: true }, confirm: true },
      { name: 'swiftCode', type: 'text', key: 'swift', rules: { required: true }, confirm: true }
    ]
  },
  {
    countries: [CountryCode.NZ],
    creditAgreement: true,
    // debitReadonlyFieldsDisplay: [
    //   { field: 'accountType', label: 'paymentType' },
    //   { field: 'financialInstitution', label: 'institution' },
    //   { field: 'routingNumber', label: 'routing' },
    //   { field: 'accountNumber', label: 'accountNumber' }
    // ],
    fields: [
      { name: 'paymentType', key: 'paymentType', type: 'type', rules: { required: true } },
      { name: 'financialInstitution', key: 'institution', type: 'text', rules: { required: true } },
      { name: 'routingNumber', key: 'routing', type: 'text', rules: { required: true }, confirm: true },
      { name: 'accountNumber', type: 'text', key: 'accountNumber', rules: { required: true }, confirm: true, placeholderField: 'maskedAccountNumber' }
    ]
  }
]
